"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileSettings = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const wallet_1 = require("./wallet");
const ProfileSettings = (props) => {
    const { open } = props;
    if (!open) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { children: (0, jsx_runtime_1.jsx)(wallet_1.Wallet, {}) }));
};
exports.ProfileSettings = ProfileSettings;
//# sourceMappingURL=index.js.map